import { useRef, useCallback } from 'react';
import useWindowListener from '../useWindowListener/index.js';

var useClickOutside = function useClickOutside(callback) {
  var elementRef = useRef(null);
  var handler = useCallback(function (event) {
    if (elementRef.current && !elementRef.current.contains(event.target)) {
      callback(event);
    }
  }, [callback]);
  useWindowListener('click', handler);
  return elementRef;
};

export { useClickOutside as default };
//# sourceMappingURL=index.js.map
